import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    salutation: string,
    academicTitle:string,
    entranceDate: Date | null,
    location: string,
    salaryRequest: number | null,
    workTime: number | null,
    otherPositionsOption:string,
    remarks: string,
    stateExamination2: number | null,
    stateExamination1: number | null,
    stateExamination1state: number | null,
    stateExamination1university: number | null,
    highschoolgrade: number | null,
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string){
        this.displayName = displayName;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    salutation: string="";
    academicTitle:string="";
    location: string="";
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    entranceDate: Date | null = null;
    salaryRequest: number | null = null;
    workTime: number | null = null;
    otherPositionsOption:string="";
    remarks: string="";
    stateExamination2: number | null = null;
    stateExamination1: number | null = null;
    stateExamination1state: number | null = null;
    stateExamination1university: number | null = null;
    highschoolgrade: number | null = null;
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "salutation", value: this.salutation ? this.salutation:"Neutral"},
            { name: "academicTitle", value: this.academicTitle},
            { name: "location", value: this.location},
            { name: "entranceDate", value: this.entranceDate?.toString() ?? "" },
            { name: "salaryRequest", value: this.salaryRequest?.toString() ?? "" },
            { name: "workTime", value: this.workTime?.toString() ?? "" },
            { name: "otherPositionsOption", value: this.otherPositionsOption},
            { name: "remarks", value: this.remarks},
            { name: "stateExamination2", value: this.stateExamination2?.toString() ?? "" },
            { name: "stateExamination1", value: this.stateExamination1?.toString() ?? "" },
            { name: "stateExamination1state", value: this.stateExamination1state?.toString() ?? "" },
            { name: "stateExamination1university", value: this.stateExamination1university?.toString() ?? "" },
            { name: "highschoolgrade", value: this.highschoolgrade?.toString() ?? "" },
        );

        return application;
    }
}
